<template>
    <div class="hero-head">
        <div class="container">

        </div>
    </div>
</template>

<script>
export default {
  name: 'Head',
};
</script>

<style lang="scss">
</style>
